module.exports = "<!--Footer Starts-->\r\n<footer>\r\n    <div class=\"container-fluid\">\r\n        <p class=\"copyright text-center\">\r\n            &copy; {{currentDate | date: 'yyyy'}} <a>DPDT/CIN</a>, Tecnologia da Informação a serviço da GMRIO\r\n            <!--&copy;  <a>PIXINVENT</a>, made with love for a better web-->\r\n        </p>\r\n    </div>\r\n</footer>\r\n<!--Footer Ends-->"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer/footer.component.html
// module id = ./src/app/shared/footer/footer.component.html
// module chunks = main